import React from 'react';
import { buildImageSource, buildImageSourceSet } from '../../utils/buildImageSource';
import { formatCurrency } from '../../utils/format/formatCurrency';
import { useTranslation } from '../../utils/useTranslation';
import { IconClose } from '../icon/IconClose';
import { IconPlus } from '../icon/IconPlus';
import { IconButton } from '../input/IconButton';
import { Flex } from '../layout/Flex';
import { Stack } from '../layout/Stack';
import { Image } from '../media/Image';
import { MediaCover } from '../media/MediaCover';
import { Retry } from '../media/Retry';
import { Typography } from '../typography/Typography';
import { ProductItemUI } from './types';

interface PostPersistenceProductsProps {
    onRemoveProduct: (productId: string) => void;
    products: ProductItemUI[];
    showAddProductsDrawer: VoidFunction;
}

export const PostPersistenceProducts = (props: PostPersistenceProductsProps) => {
    const t = useTranslation();
    const { onRemoveProduct, showAddProductsDrawer, products } = props;

    return (
        <Flex width="100%" pb={1}>
            <Stack
                width="100%"
                count={products.length}
                pb={1}
                renderItem={(index: number) => (
                    <Flex
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        width="100%"
                        key={products[index].id}
                    >
                        <Flex direction="row" py={1} alignItems="center" spacing={1}>
                            <MediaCover
                                ratio={1}
                                height={80}
                                width={80}
                                minWidth={80}
                                borderRadius={2.5}
                                border="0.5px solid var(--divider)"
                                as="a"
                                href={products[index].url}
                                target="_blank"
                            >
                                <Retry>
                                    <Image
                                        objectFit="contain"
                                        width="100%"
                                        height="100%"
                                        src={buildImageSource(products[index].content[0].media)}
                                        srcSet={buildImageSourceSet(
                                            products[index].content[0].media,
                                        )}
                                    />
                                </Retry>
                            </MediaCover>
                            <Flex>
                                <Typography
                                    as="a"
                                    href={products[index].url}
                                    target="_blank"
                                    variant="body2"
                                >
                                    {t(products[index].title)}
                                </Typography>
                                <Typography
                                    as="a"
                                    href={products[index].url}
                                    target="_blank"
                                    variant="body"
                                    weight="bold"
                                >
                                    {formatCurrency(
                                        products[index].priceInfo.integerPart,
                                        products[index].priceInfo.fractionalPart,
                                    )}
                                </Typography>
                            </Flex>
                        </Flex>
                        <IconButton onClick={() => onRemoveProduct(products[index].id)}>
                            <IconClose />
                        </IconButton>
                    </Flex>
                )}
            />
            {products.length > 0 && (
                <Flex
                    width="100%"
                    border="2px dashed var(--divider)"
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                    cursor="pointer"
                    p={1.75}
                    borderRadius={2}
                    spacing={2}
                    onClick={showAddProductsDrawer}
                >
                    <Flex
                        p={1}
                        borderRadius={2.5}
                        backgroundColor="var(--control-secondary-background)"
                    >
                        <IconPlus size={24} />
                    </Flex>
                    <Typography variant="caption" weight="bold">
                        ДОБАВИТЬ ЕЩЕ ТОВАРЫ
                    </Typography>
                </Flex>
            )}
        </Flex>
    );
};
